import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=3c1dff60&scoped=true&lang=pug"
import script from "./LeadsList.vue?vue&type=script&lang=js"
export * from "./LeadsList.vue?vue&type=script&lang=js"
import style0 from "./LeadsList.vue?vue&type=style&index=0&id=3c1dff60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1dff60",
  null
  
)

export default component.exports